import { css } from 'styled-components';

const styles = css`
  .category-pill-container {
    ${(props) =>
      `border-top: 1px solid ${props.theme.colors.BORDER_ALPHA};
       font-family: ${props.theme.typography.fonts.primary};
       margin-top: 32px;

    .category-pill-list {
      display: flex;
      flex-wrap: wrap;
    }

    .category-pill {
        margin-bottom: 12px;
        margin-right: 14px;

      a {
        border: 1px solid ${props.theme.colors.PRIMARY.GRAY};
        border-radius: 6px;
        color: ${props.theme.colors.TEXT.DARK};
        display: block;
        padding: 16px 20px;
        text-decoration: none;
        width: fit-content;

        &:hover {
          border: 1px solid ${props.theme.colors.BLACK};
          color: ${props.theme.colors.BLACK};
        }
      }
    }

    .category-pill-heading {
        color: ${props.theme.colors.BLACK};
        font-size: 22px;
        font-weight: bold;
        line-height: 22px;
        margin: 32px 0;
        padding-bottom: 5px;
    }
  `}
  }
`;

export default styles;
